import React from "react";

export const formatRole = (role) =>
  String(role || "")
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/^\w/, (c) => c.toUpperCase());

export const roleBadgeClass = (role) => {
  switch (role) {
    case "BUSINESS_OWNER":
      return "badge rounded-pill text-bg-warning text-dark";
    case "ADMIN":
      return "badge rounded-pill text-bg-primary";
    case "AGENT":
      return "badge rounded-pill text-bg-success";
    default:
      return "badge rounded-pill text-bg-secondary";
  }
};

export const statusBadgeClass = (active) =>
  active
    ? "badge rounded-pill bg-success-subtle text-success-emphasis border border-success-subtle"
    : "badge rounded-pill bg-danger-subtle text-danger-emphasis border border-danger-subtle";

export default function UserProfileCard({
  user,
  createdAt,
  lastLogin,
  actions,
}) {
  if (!user) return null;

  const fullName = `${user.firstName || ""} ${user.lastName || ""}`.trim() || user.email || "—";
  const initials = `${user.firstName?.[0] || ""}${user.lastName?.[0] || ""}`.toUpperCase();

  return (
    <div className="card border-0 shadow-sm rounded-4">
      <div className="card-body">
        <div className="d-flex flex-wrap gap-4 align-items-center">
          <div
            className="rounded-circle bg-body-secondary text-body fw-bold d-flex align-items-center justify-content-center"
            style={{ width: 64, height: 64 }}
          >
            {initials || <i className="bi bi-person" aria-hidden="true" />}
          </div>
          <div className="flex-grow-1">
            <div className="d-flex flex-wrap align-items-center gap-3">
              <h4 className="mb-0">{fullName}</h4>
              <span className={statusBadgeClass(user.active)}>
                {user.active ? "Active" : "Inactive"}
              </span>
            </div>
            <div className="text-body-secondary mt-2 d-flex flex-column gap-1">
              <span><i className="bi bi-envelope me-2" />{user.email || "—"}</span>
              <span><i className="bi bi-telephone me-2" />{user.phone || "—"}</span>
              <span><i className="bi bi-geo me-2" />{(user.country || "").toUpperCase() || "—"}</span>
            </div>
            <div className="mt-3 d-flex flex-wrap gap-2">
              {(user.roles || []).map((role, idx) => (
                <span key={`${role}-${idx}`} className={roleBadgeClass(role)}>
                  {formatRole(role)}
                </span>
              ))}
            </div>
          </div>
        </div>
        <hr className="my-4" />
        <div className="row g-3 text-body-secondary">
          <div className="col-12 col-md-4">
            <small className="d-block text-uppercase fw-semibold">Created</small>
            <span>{createdAt || "—"}</span>
          </div>
          <div className="col-12 col-md-4">
            <small className="d-block text-uppercase fw-semibold">Last login</small>
            <span>{lastLogin || "—"}</span>
          </div>
          <div className="col-12 col-md-4">
            <small className="d-block text-uppercase fw-semibold">Business ID</small>
            <span>{user.businessId ?? "—"}</span>
          </div>
        </div>

        {actions && (
          <div className="mt-4 d-flex flex-wrap gap-2">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}
